// Tiempos de los pasos que pueden tardar (entrar, salir, cobrar, sincronizar), para diagnosticar
// lentitud en un dispositivo. Se guardan los últimos en este navegador y se ven en Sincronización.

export interface Timing {
  label: string;
  ms: number;
  at: string;
  failed?: boolean;
}

const KEY = 'pos-saas-timings';
const MAX = 40;

export function recordTiming(label: string, ms: number, failed = false): void {
  try {
    const list = recentTimings();
    list.unshift({ label, ms: Math.round(ms), at: new Date().toISOString(), ...(failed ? { failed } : {}) });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    // Sin almacenamiento: no se anota (no afecta a la app).
  }
}

/** Mide cuánto tarda un paso y lo anota (también si falla). */
export async function timed<T>(label: string, fn: () => Promise<T>): Promise<T> {
  const start = performance.now();
  let failed = false;
  try {
    return await fn();
  } catch (error) {
    failed = true;
    throw error;
  } finally {
    recordTiming(label, performance.now() - start, failed);
  }
}

export function recentTimings(): Timing[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Timing[]) : [];
  } catch {
    return [];
  }
}

export function clearTimings(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nada
  }
}
